    import React, { useContext, useEffect, useState, useRef } from "react";
    import Box from '@mui/material/Box'
    import Typography from '@mui/material/Typography';
    import {Link} from 'react-router-dom';
    import TextField from '@mui/material/TextField';
    import Container from  '@mui/material/Container'
    import Button from '@mui/material/Button';
    import Grid from '@mui/material/Grid';
    import './Login.css';
    import Stack from '@mui/material/Stack';
    import '@fontsource/roboto/300.css';
    import { useHistory } from 'react-router-dom';
    import api from '../../services/api';
    import { Cookies } from 'react-cookie';
    import { ToastContainer, toast } from 'react-toastify';
    import { MyContext } from '../../context/MyContext';
    import 'react-toastify/dist/ReactToastify.css';
    import { BrowserView, MobileView } from 'react-device-detect';
    import { useLocation } from 'react-router-dom';
    
    export default function() {
        const { destinoPagina, setDestinoPagina } = useContext(MyContext);    
        const { usuarioComprasFaturadas, setUsuarioComprasFaturadas } = useContext(MyContext);
        const [usuarioAssociadoMaisUmaConta, setUsuarioAssociadoMaisUmaConta] = useState(false); // Armazena Se o E-Mail Está Associado a Mais de Uma Conta (Normalmente Contas Faturadas)
        const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
        const [administrador, setAdministrador] = useState(0);   // Armazena Se É Administrador        
        // const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState(""); // Armazena Criptografado o Nome do Usuário Logado
        const {nomeUsuarioLogado, setNomeUsuarioLogado} = useContext(MyContext); // Armazena Criptografado o Nome do Usuário Logado
        const [nomeFullRazaoSocialLogado, setNomeFullRazaoSocialLogado] = useState("");
        const {usuarioEfetuouLogin, setUsuarioEfetuouLogin } = useContext(MyContext);
        const {aguardandoCodigoVerificacao, setAguardandoCodigoVerificacao} = useContext(MyContext);
        const {usuarioEfetuouLoginEMail, setUsuarioEfetuouLoginEMail} = useContext(MyContext);
        const { openDadosPessoais, setOpenDadosPessoais } = useContext(MyContext);
        
        const location = useLocation();

        let navigate = useHistory();

        function delay(time) {
            // return new Promise(resolve => setTimeout(resolve, time));
        }
        
        async function AguardarToast() {
            // await delay(5000);
        }

    const toastErroEmail = () => toast.error("Por Favor, Utilize um E-Mail Válido!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastErroSenha = () => toast.error("Por Favor, Digite a Sua Senha!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastErroNaoCadastro = () => toast.warning("O E-Mail ou Senha Digitado Não Pode Ser Localizado!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastErroApiNaoResponde = () => toast.error("Ops, Alguma Coisa Errada com Nosso Servidor!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastLoginSucesso = (nome) => toast.success("Bem Vindo, " + nome,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const erroEmail = () => toast.error("Por Favor, Use um E-Mail Válido!",
    {position: toast.POSITION.TOP_CENTER , theme: "colored"});

    const erroSenha = () => toast.error("Por Favor, Digite a Sua Senha!",
    {position: toast.POSITION.TOP_CENTER , theme: "colored"});

    const erroNaoCadastro = () => toast.warning("Usuário Não cadastrado, ou dados de acesso Incorretos",
    {position: toast.POSITION.TOP_CENTER , theme: "colored"});

    const loginSucesso = (nome) => toast.success("Bem Vindo, " + nome,
    {position: toast.POSITION.TOP_CENTER , theme: "colored", autoClose:2000 });

        const ValidarEmail = (email) => {
            if (email.length === 0 || !email.includes('@')) {
                return false;
            }
            else{
                return true;
            }
        }
        const ValidarSenha = (senha) => {
            if (senha.length === 0) {
                return false;
            }
            else{
                return true;
            }
        }

        const logar = async (event) => {
            event.preventDefault();
            const userMail = document.getElementById('meuEmail');
            const userPassword = document.getElementById('minhaSenha');
            const vEmail = ValidarEmail(userMail.value);
            if (!vEmail) {
                toastErroEmail();
                return false;
            }
            const vSenha = ValidarSenha(userPassword.value);
            if (!vSenha) {
                // setTipoFrete(-1);
                toastErroSenha();
                return false;
            }
            // setUsuarioAssociadoMaisUmaConta

            var verificarUsuarioMaisContas = api.get(`Clientes/ClienteContasAssociadas/${userMail.value}`)
                .then(res => {
                    if (res.contasAssociadas > 1) {
                        setUsuarioAssociadoMaisUmaConta(true);
                    }
                    else {
                        setUsuarioAssociadoMaisUmaConta(false);
                    }
                    return true;
                }).catch(err => {
                    if (err == "Error: Network Error") {
                        toastErroApiNaoResponde();
                    }
                    else {
                        toastErroNaoCadastro();
                    }
                    return false;
                });            
            const formData = new FormData();
            formData.append('email', userMail.value);
            formData.append('password', userPassword.value);
            const cookies = new Cookies();
            const xsrfToken = cookies.get('XSRF-TOKEN');
            var saveIn = await api.post('Clientes/Login', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-XSRF-TOKEN': xsrfToken
                }
            }).then(res => {
                // toastLoginSucesso(res?.data?.razao_social.split(' ').slice(0, 2).join(' '));
                let razaoSocialUsuarioLogado = res?.data?.razao_social.split(' ').slice(0, 2).join(' ');
                let usuarioLogado = sessionStorage.getItem("id_loja_usuario");
                setAdministrador(0);  
                if (usuarioLogado == "2413_1"){
                    setAdministrador(1);
                }                
                // if (usuarioLogado) {
                //     sessionStorage.removeItem("id_loja_usuario");
                //     sessionStorage.removeItem("hash_usuario");
                //     sessionStorage.removeItem("nome_usuario_logado");
                //     sessionStorage.removeItem("nome_razao_social_logado");
                //     sessionStorage.removeItem("usuario_compras_faturado");                    
                //     // setUsuarioComprasFaturadas(0);
                //     var saveQuemLogou = Buffer.from(res?.data?.ids_clientes + "_" + res?.data?.ids_loja).toString('base64');
                //     // console.log("USERUUU", res?.data);
                //     setDestinoPagina("verificacao");
                //     setAguardandoCodigoVerificacao(true);
                //     // navigate.push("/verificacao");
                //     console.log("VacaPEDRO", usuarioEfetuouLogin, usuarioLogado);
                // }
                // else {
                    sessionStorage.removeItem("id_loja_usuario");
                    sessionStorage.removeItem("hash_usuario");
                    sessionStorage.removeItem("usuario_compras_faturado");
                    var saveQuemLogou = Buffer.from(res?.data?.ids_clientes + "_" + res?.data?.ids_loja).toString('base64');
                    var saveNomeUsuarioQueLogou = Buffer.from(razaoSocialUsuarioLogado).toString('base64');
                    sessionStorage.setItem("nome_razao_social_logado", "MRnSt" + Buffer.from(res?.data?.razao_social).toString('base64').replaceAll("=", "!") + "POsr34qa2esTraAb==");
                    sessionStorage.setItem("nome_usuario_logado", "WsopOTy" + Buffer.from(res?.data?.nome).toString('base64').replaceAll("=", "!") + "XwQq43s741wOpUUsVbqa==");
                    sessionStorage.setItem("id_loja_usuario", "Pr" + saveQuemLogou + "YfhR7sFdS53a==");
                    sessionStorage.setItem("hash_usuario", "tW" + saveNomeUsuarioQueLogou.replaceAll("=", "!") + "ReH5jQUX681z==");
                    sessionStorage.setItem("usuario_compras_faturado", res?.data?.faturado);
                    // usuarioLogado = sessionStorage.getItem("id_loja_usuario");                    
                    setUsuarioEfetuouLogin(res?.data?.ids_clientes + "_" + res?.data?.ids_loja);                    
                    setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
                    setNomeFullRazaoSocialLogado(res?.data?.razao_social);
                    setUsuarioLogado(res?.data?.ids_clientes + "_" + res?.data?.ids_loja);
                    setNomeUsuarioLogado(res?.data?.nome);
                    setUsuarioComprasFaturadas(res?.data?.faturado);
                    setUsuarioEfetuouLoginEMail(res?.data?.email);                     
                    setAguardandoCodigoVerificacao(true);
                    if (destinoPagina === "faturado" && res?.data?.faturado != 1){
                      navigate.push("/");                      
                      return true;
                    }

                    if (destinoPagina){
                        if ('/' + destinoPagina == location.pathname){
                            navigate.replace('/' + destinoPagina);    
                            window.location.reload();
                        }
                        else{
                            navigate.push('/' + destinoPagina);
                        }    
                    }                    
                    // PegarEnderecoPadrao();
                    // MostrarOpcoesFretes();
                //}
                return true;
            }).catch(err => {
                sessionStorage.removeItem("id_loja_usuario");
                sessionStorage.removeItem("hash_usuario");
                sessionStorage.removeItem("nome_usuario_logado");
                sessionStorage.removeItem("nome_razao_social_logado");
                sessionStorage.removeItem("usuario_compras_faturado");
                setAguardandoCodigoVerificacao(true);
                // setUsuarioComprasFaturadas(0);
                if (err == "Error: Network Error") {
                    toastErroApiNaoResponde();
                }
                else {
                    toastErroNaoCadastro();
                }
                return false;
            });
            // if (saveIn) {
            //     // Aguarda o Toast Para Enviar Outra Página
            //     // await new Promise(resolve => setTimeout(resolve, 2000));
            //     // navigate.push('/home');
            //     // ATIVAR BOTAO FINALIZAR PEDIDO
            // }
        }         

    return (
        <div>
        <BrowserView>
        <br />
        <br />
        <br />
        <Container maxWidth = "lg" className="corpo">
                <Grid container justifyContent={"center"} spacing={2}> 
                    <Grid item  xs={12} md={12}>
                        <Box className="tipografia" sx={{ width: "100%"}}  >
                                <Typography sx={{textAlign: "center", fontFamily: "roboto"}}variant="h4" component="div" gutterBottom>
                                    Acessar Minha Conta NAFIL
                                </Typography>
                                <Typography sx={{textAlign: "center", fontFamily: "roboto" }}variant="h7" component="div" gutterBottom>
                                    Não tem uma conta? <Link to='/Cadastro'> Registre-se aqui </Link>
                                </Typography>
                        </Box>
                        <br />
                        <br />
                </Grid>
                    <Grid container justifyContent={"center"} xs={12} md={12}>
                            <Box sx={{width: "450px"}} >
                            <Stack direction= "column" spacing={2} >
                                    <TextField
                                        fullWidth
                                        id="meuEmail"
                                        name="meuEmail"
                                        size = "normal"                
                                        label = "Digite o seu email"
                                        type="text"
                                    />
                                    <TextField
                                        fullWidth
                                        id="minhaSenha"
                                        name="minhaSenha"
                                        size = "normal"
                                        label = "Senha"
                                        type = "password"
                                    /> 
                                <Button
                                variant="contained"
                                onClick={(e) => 
                                    logar(e)
                                }
                                sx={{background: 'green' }}>
                                    Entrar
                                </Button>
                                <Typography sx={{textAlign: "center", fontFamily: "roboto" }}variant="h9" component="div">
                                    Esqueci Minha Senha <Link to='/esqueci_minha_senha'>Clique aqui</Link>
                                </Typography>
                            </Stack>
                        </Box>
                </Grid>
            </Grid>
        </Container>
        <ToastContainer/>
        </BrowserView>

        <MobileView>
        <br />
        <br />
        <br />
        <Container maxWidth = "lg" className="corpo">
                <Grid container justifyContent={"center"} spacing={2}> 
                    <Grid item  xs={12} md={12}>
                        <Box className="tipografia" sx={{ width: "100%"}}  >
                                <Typography sx={{textAlign: "center", fontFamily: "roboto"}}variant="h4" component="div" gutterBottom>
                                    Acessar Minha Conta NAFIL
                                </Typography>
                                <Typography sx={{textAlign: "center", fontFamily: "roboto" }}variant="h7" component="div" gutterBottom>
                                    Não tem uma conta? <Link to='/Cadastro'> Registre-se </Link>
                                </Typography>
                        </Box>
                        <br />
                        <br />
                </Grid>
                    <Grid container justifyContent={"center"} xs={12} md={12}>
                            <Box sx={{width: "80%"}} >
                            <Stack direction= "column" spacing={2} >
                                    <TextField
                                        fullWidth
                                        id="meuEmail"
                                        name="meuEmail"
                                        size = "normal"                
                                        label = "Digite o seu email"
                                        type="text"
                                    />
                                    <TextField
                                        fullWidth
                                        id="minhaSenha"
                                        name="minhaSenha"
                                        size = "normal"
                                        label = "Senha"
                                        type = "password"
                                    /> 
                                <Button
                                variant="contained"
                                onClick={(e) => 
                                    logar(e)
                                }
                                sx={{background: 'green' }}>
                                    Entrar
                                </Button>
                                <Typography sx={{textAlign: "center", fontFamily: "roboto" }}variant="h9" component="div">
                                        Esqueci Minha Senha <Link to='/esqueci_minha_senha'>Clique aqui</Link>
                                </Typography>                           
                            </Stack>
                        </Box>
                </Grid>
            </Grid>
        </Container>
        <ToastContainer/>
        </MobileView>

        </div>
    )
    }
